<template>
  <div
    class="service-item-container normal-button"
    v-bind:class="{ active: isSelected }"
    @click="onClick"
  >
    <span class="title" v-bind:class="{ 'title-active': isSelected }">{{
      title
    }}</span>
    <img v-if="isSelected" src="@/assets/ic_check.png" class="icon" />
    <img v-else src="@/assets/ic_plus.png" class="icon" />
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      isRequired: true,
    },
    isSelected: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onClick() {
      this.$emit("onItemClick");
    },
  },
};
</script>

<style lang="scss" scoped>
.active {
  background-color: #2e2323;
  border: none;
}
.title-active {
  color: white;
}
.title {
  font-family: "SFUIText-Medium", -apple-system;
  font-weight: 500;
  font-size: 16px;
}
.service-item-container {
  display: flex;
  align-items: center;
  margin-right: 15px;
  margin-bottom: 15px;
  padding: 15px;
  border: 1.5px solid #eeeeee;
  border-radius: 6px;
  .icon {
    height: 25px;
    width: auto;
    margin-left: 15px;
  }
}
</style>